import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Import original pages
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";

// Import TypeScript pages
import Home from "./pages/Home.tsx";
import Login from "./pages/Login.tsx";
import SelectGrade from "./pages/SelectGrade.tsx";
import Quiz from "./pages/Quiz.tsx";
import Result from "./pages/Result.tsx";
import Profile from "./pages/Profile.tsx";

export default function App() {
  const [user, setUser] = useState(null);
  useEffect(() => onAuthStateChanged(auth, setUser), []);

  return (
    <BrowserRouter>
      <Routes>
        {/* If user is not authenticated, only allow access to auth pages */}
        {!user ? (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="*" element={<Navigate to="/auth" replace />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/select-grade" element={<SelectGrade />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/result" element={<Result />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
} 